import { Link, useLocation, useNavigate, useSearchParams } from "react-router-dom"
import "../css/header.css";
import { Searching } from "./search";
import { DocsIcon } from "./home";

function Logo() {

   return (
      <Link to="/" className="logo"  >
         <figure></figure>
      </Link>
   )
}

function CloseButton() {
   return (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
         <path fillRule="evenodd" d="M12,2 C17.5229861,2 22,6.47701386 22,12 C22,17.5229861 17.5229861,22 12,22 C6.47701386,22 2,17.5229861 2,12 C2,6.47701386 6.47701386,2 12,2 Z M13.4142136,12 L16.2426407,9.17157288 C16.633165,8.78104858 16.633165,8.1478836 16.2426407,7.75735931 C15.8521164,7.36683502 15.2189514,7.36683502 14.8284271,7.75735931 L12,10.5857864 L9.17157288,7.75735931 C8.78104858,7.36683502 8.1478836,7.36683502 7.75735931,7.75735931 C7.36683502,8.1478836 7.36683502,8.78104858 7.75735931,9.17157288 L10.5857864,12 L7.75735931,14.8284271 C7.36683502,15.2189514 7.36683502,15.8521164 7.75735931,16.2426407 C8.1478836,16.633165 8.78104858,16.633165 9.17157288,16.2426407 L12,13.4142136 L14.8284271,16.2426407 C15.2189514,16.633165 15.8521164,16.633165 16.2426407,16.2426407 C16.633165,15.8521164 16.633165,15.2189514 16.2426407,14.8284271 L13.4142136,12 Z" />
      </svg>
   )
}

function SearchContainer(params) {
   var nav = useNavigate();
   var { pathname } = useLocation();

   function goToSearch() {
      if (pathname === '/search') return;
      console.log('go to search');
      nav('/search');
   }

   window.onkeydown = false;
   window.onkeydown = e => {
      if (e.ctrlKey && e.code === 'KeyF') {
         e.preventDefault();
         goToSearch();
      }
   }

   return (
      <div className="search">
         <button>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" version="1.1">
               <path d="M9.7388,8.8817842e-14 C15.1088,8.8817842e-14 19.4768,4.368 19.4768,9.738 C19.4768,12.2715459 18.5045194,14.5822774 16.9134487,16.3164943 L20.0442,19.4407 C20.3372,19.7337 20.3382,20.2077 20.0452,20.5007 C19.8992,20.6487 19.7062,20.7217 19.5142,20.7217 C19.3232,20.7217 19.1312,20.6487 18.9842,20.5027 L15.8156604,17.3430042 C14.1488713,18.6778412 12.0354764,19.477 9.7388,19.477 C4.3688,19.477 -0.0002,15.108 -0.0002,9.738 C-0.0002,4.368 4.3688,8.8817842e-14 9.7388,8.8817842e-14 Z M9.7388,1.5 C5.1958,1.5 1.4998,5.195 1.4998,9.738 C1.4998,14.281 5.1958,17.977 9.7388,17.977 C14.2808,17.977 17.9768,14.281 17.9768,9.738 C17.9768,5.195 14.2808,1.5 9.7388,1.5 Z" />
            </svg>
         </button>
         <input
            title="Alakazam"
            className="input-target"
            type='text'
            placeholder="Search (CTRL + F)"
            required
            onKeyUp={Searching.bind(this, params)}
            onInput={goToSearch}
         />
         <button onClick={e => {
            e.target.previousElementSibling.value = '';
         }}>
            <CloseButton />
         </button>
      </div>
   )
}

export default function Header() {
   var [ param, setParam ] = useSearchParams();

   function showMenu() {
      var menu = window.menuElement;
      if (!menu) {
         menu = window.menuElement = document.getElementById("menu");
      }

      if (!menu.classList.contains("visible")) {
         menu.classList.add("visible");
         return
      }
      menu.classList.remove("visible");

   }

   return (
      <>
         <header className="glass">
            <nav>
               <Logo />
               <span></span>
               <Link to="./docs">Docs</Link>
               <Link to="./guides">Guides</Link>
               <Link to="./download">Download</Link>
               <Link to="./admin">Dashboard</Link>
               <SearchContainer setSearch={setParam} />
               <button className="show" onClick={showMenu}><DocsIcon /></button>
            </nav>
         </header>

         <div id="menu" className="glass" onClick={showMenu}>
            <button><CloseButton /></button>
            <Link to="./docs">Docs</Link>
            <Link to="./guides">Guides</Link>
            <Link to="./download">Download</Link>
            <Link to="./admin">Dashboard</Link>
         </div>
      </>
   )
}

export { SearchContainer }